import { Component, inject, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthModalService } from '../../../services/auth-modal.service';

@Component({
  selector: 'app-modal-register',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-register.component.html',
  styleUrl: './modal-register.component.scss',
})
export class ModalRegisterComponent {
  private readonly modalService = inject(AuthModalService);

  readonly volverALogin = output<void>();

  email = '';
  password = '';
  confirmPassword = '';
  nombre = '';
  apellido = '';
  pais = 'Perú';
  codigoPais = '+51';
  telefono = '';
  tipoDoc = 'DNI';
  numDoc = '';
  fechaNac = '';
  genero = '';

  captchaChecked = false;
  aceptaInfo = false;
  aceptaPoliticas = false;

  readonly paises = ['Perú', 'Colombia', 'Argentina', 'Chile', 'México', 'España', 'Estados Unidos', 'Otro'];
  readonly codigos = ['+51', '+57', '+54', '+56', '+52', '+34', '+1'];
  readonly tiposDoc = ['DNI', 'Pasaporte', 'CE'];
  readonly generos = ['Masculino', 'Femenino', 'Prefiero no indicar'];

  goToLogin(): void {
    this.volverALogin.emit();
    this.modalService.switchTo('login');
  }

  register(): void {
    this.modalService.switchTo('verificacion');
  }
}
